import { useCallback } from "react";

import { FormInstance, message } from "antd";
import { StepThreePaymentMethodForm } from "../interfaces";

export const useFileHandler = (stepThreePaymentMethodForm:FormInstance<StepThreePaymentMethodForm> | undefined) => {
  const openFile = useCallback((file:any) => {
    let messageError = 'No hay archivo seleccionado o el archivo está vacío.';

    if (file?.base) {
      const newWindow = window.open();

      if (newWindow) {
        const document = `<iframe src="${file.base}" style="width:100%; height:100%;"></iframe>`;
        newWindow.document.write(document);
        return;
      }

      messageError =
        'La ventana emergente no se pudo abrir. Asegúrate de que las ventanas emergentes no estén bloqueadas en tu navegador.';
    }

    message.error(messageError);
  }, []);

  const handlerUpload = useCallback((fileSelected:React.SetStateAction<any[]>) => {
    stepThreePaymentMethodForm?.setFieldValue(
      'proofOfPayment',
      fileSelected.length
    );
  }, [stepThreePaymentMethodForm]);

  const cutText = (text: string, maxLength: number) => {
    if (text.length > maxLength) return `${text.substring(0, maxLength)}...`;

    return text;
  };

  return { openFile, handlerUpload, cutText };
}